"use client";

import { AnalyticsScript as GoogleAnalyticsScript } from "./provider/google";
import { AnalyticsScript as LinkedInInsightScript } from "./provider/linkedin";
import { AnalyticsScript as PostHogScript } from "./provider/posthog";

const googleTagId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
const linkedInPartnerId = process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID;

const production = process.env.NODE_ENV === "production";
/**
 * Composite analytics script that loads multiple analytics providers:
 * - PostHog: Primary analytics for event tracking and user identification
 * - Google Analytics: For AI referrer tracking and traffic source analysis
 * - LinkedIn Insight Tag: For ad attribution, conversions and retargeting
 */
export function AnalyticsScript() {
	return (
		<>
			{production && <PostHogScript />}
			{production && googleTagId && <GoogleAnalyticsScript />}
			{production && linkedInPartnerId && <LinkedInInsightScript />}
		</>
	);
}
